import { type PropsWithChildren, SVGProps } from 'react';

/**
 * Component to wrap a child element into a foreign object forcing the parent to be position fixed.
 * The main goal of this wrapper is to prevent positioning issues on Safari.
 */
export const ForeignObjectWrapper = ({
  children,
  ...props
}: PropsWithChildren<SVGProps<SVGForeignObjectElement>>) => {
  return (
    <foreignObject {...props}>
      <div style={{ position: 'fixed' }}>{children}</div>
    </foreignObject>
  );
};
